import QrCode from '../qrCode/qrCode.js';
// import { Link } from "react-router-dom";

const Home=()=>{

    return (        
       <>
         {/* <Link to="/qr">Go to QR</Link> */}
          <table style={{ margin: "auto" }}>
  <tbody>
    <tr>
      <td style={{ padding: "20px" }}>
        <QrCode id="1731279-1" />
      </td>
      <td style={{ padding: "20px" }}>
        <QrCode id="1731279-2" />
      </td>
      <td style={{ padding: "20px" }}>
        <QrCode id="1731279-3" />
      </td>
       <td style={{ padding: "20px" }}>
        <QrCode id="1731279-4" />
      </td>
    </tr>

    <tr>
     
      <td style={{ padding: "20px" }}>
        <QrCode id="1731279-5" />
      </td>
      <td style={{ padding: "20px" }}>
        <QrCode id="1731279-6" />
      </td>
        <td style={{ padding: "20px" }}>
        <QrCode id="1731279-7" />
      </td>
    </tr>
  </tbody>
</table>
       </>
    )
}

export default Home;